import axios from "axios";
import consoleLog from "../utils/consoleLog";

const API = axios.create({
  baseURL:
    process.env.NODE_ENV === "development"
      ? `${process.env.REACT_APP_PETOBE_SHOPPING_SERVICES_API_BASE_URL_DEV}`
      : `${process.env.REACT_APP_PETOBE_SHOPPING_SERVICES_API_BASE_URL_PROD}`,
});

export const getCart = async (userId: any) => {
  consoleLog("getCart request body", { userId });

  return await API.post(
    "/cart/getCart",
    { userId },
    {
      transformResponse: [
        (res: any) => {
          const parsedRes = JSON.parse(res);
          return parsedRes;
        },
      ],
    },
  )
    .then((res) => {
      consoleLog("getCart response", res);
      if (res?.data.body.allCartItems) {
        return res?.data.body.allCartItems;
      } else if (res.data.body.message === "Cart is empty") {
        return [];
      } else {
        return [];
      }
    })
    .catch((err) => {
      consoleLog("getCart error", err);
      throw new Error(err);
    });
};

export const addCartItems = async (cartItemsInfo: any) => {
  consoleLog("addCartItems request body", cartItemsInfo);

  return await API.post("/cart/addItems", cartItemsInfo, {
    transformResponse: [
      (res: any) => {
        const parsedRes = JSON.parse(res);
        return parsedRes;
      },
    ],
  })
    .then((res) => {
      consoleLog("addCartItems response", res);
      return res?.data.body;
    })
    .catch((err) => {
      consoleLog("addCartItems error", err);
      throw new Error(err);
    });
};

export const clearCartItem = async (clearItemInfo: any) => {
  consoleLog("clearCartItem request body", clearItemInfo);

  return await API.post("/cart/deleteCart", clearItemInfo, {
    transformResponse: [
      (res: any) => {
        const parsedRes = JSON.parse(res);
        return parsedRes;
      },
    ],
  })
    .then((res) => {
      consoleLog("clearCartItem response", res);
      return res?.data.body;
    })
    .catch((err) => {
      consoleLog("clearCartItem error", err);
      throw new Error(err);
    });
};

export const removeCartItem = async (removeItemInfo: any) => {
  consoleLog("removeCartItem request body", removeItemInfo);

  return await API.post("/cart/updateCart", removeItemInfo, {
    transformResponse: [
      (res: any) => {
        const parsedRes = JSON.parse(res);
        return parsedRes;
      },
    ],
  })
    .then((res) => {
      consoleLog("removeCartItem response", res);
      return res?.data.body;
    })
    .catch((err) => {
      consoleLog("removeCartItem error", err);
      throw new Error(err);
    });
};

export const emptyCart = async (userId: any) => {
  consoleLog("emptyCart request body", { userId });

  return await API.post(
    "/cart/deleteAllCart",
    { userId },
    {
      transformResponse: [
        (res: any) => {
          const parsedRes = JSON.parse(res);
          return parsedRes;
        },
      ],
    },
  )
    .then((res) => {
      consoleLog("emptyCart response", res);
      return res?.data.body;
    })
    .catch((err) => {
      consoleLog("emptyCart error", err);
      throw new Error(err);
    });
};

export const confirmCheckout = async ({
  userId,
  items,
  paymentMethodId,
  shipping,
}: {
  userId: string;
  items: any[];
  paymentMethodId: string;
  shipping: any;
}) => {
  consoleLog("confirmCheckout request body", {
    userId,
    items,
    paymentMethodId,
    shipping,
  });

  return await API.post(
    "/invoice/confirmCheckout",
    {
      userId,
      items,
      paymentMethodId,
      shipping,
    },
    {
      transformResponse: [
        (res: any) => {
          const parsedRes = JSON.parse(res);
          return parsedRes;
        },
      ],
    },
  )
    .then((res) => {
      if (res.data.statusCode === 400) {
        throw new Error(res.data.message);
      }
      consoleLog("confirmCheckout response", res);
      return res?.data.body;
    })
    .catch((err) => {
      consoleLog("confirmCheckout error", err);
      throw new Error(err);
    });
};

export const getReviewsByProduct = async (productId: string) => {
  consoleLog("getReviewsByProduct request body", { productId });

  return await API.get("/review/getReviewsByProduct", {
    params: {
      productId,
    },
    transformResponse: [
      (res: any) => {
        const parsedRes = JSON.parse(res);
        return parsedRes;
      },
    ],
  })
    .then((res) => {
      consoleLog("getReviewsByProduct response", res);
      return res.data.body;
    })
    .catch((err) => {
      consoleLog("getReviewsByProduct error", err);
      throw new Error(err);
    });
};

export const getReviewsByUser = async (userId: string) => {
  consoleLog("getReviewsByUser request body", { userId });

  return await API.get("/review/getReviewsByUser", {
    params: {
      userId,
    },
    transformResponse: [
      (res: any) => {
        const parsedRes = JSON.parse(res);
        return parsedRes;
      },
    ],
  })
    .then((res) => {
      consoleLog("getReviewsByUser response", res);
      return res.data.body;
    })
    .catch((err) => {
      consoleLog("getReviewsByUser error", err);
      throw new Error(err);
    });
};

export const createReview = async (params: {
  productId: string;
  userId: string;
  rate: number;
  bodyText?: string;
  reviewImageList?: string[];
}) => {
  consoleLog("createReview request body", params);

  return await API.post("/review/createReview", params, {
    transformResponse: [
      (res: any) => {
        const parsedRes = JSON.parse(res);
        return parsedRes;
      },
    ],
  })
    .then((res) => {
      consoleLog("createReview response", res);
      return res.data.body;
    })
    .catch((err) => {
      consoleLog("createReview error", err);
      throw new Error(err);
    });
};

export const deleteReview = async (params: {
  productId: string;
  userId: string;
  reviewId: string;
}) => {
  consoleLog("deleteReview request body", params);

  return await API.post("/review/deleteReview", params, {
    transformResponse: [
      (res: any) => {
        const parsedRes = JSON.parse(res);
        return parsedRes;
      },
    ],
  })
    .then((res) => {
      consoleLog("deleteReview response", res);
      return res.data.body;
    })
    .catch((err) => {
      consoleLog("deleteReview error", err);
      throw new Error(err);
    });
};

export const updateReview = async (params: {
  productId: string;
  userId: string;
  reviewId: string;
  rate: number;
  bodyText?: string;
  reviewImageList?: string[];
}) => {
  consoleLog("updateReview request body", params);

  return await API.post("/review/updateReview", params, {
    transformResponse: [
      (res: any) => {
        const parsedRes = JSON.parse(res);
        return parsedRes;
      },
    ],
  })
    .then((res) => {
      consoleLog("updateReview response", res);
      return res.data.body;
    })
    .catch((err) => {
      consoleLog("updateReview error", err);
      throw new Error(err);
    });
};
